import { Button, Icon, Text } from '@user-portal/wikr-components';
import React from 'react';
import { Link } from 'react-router-dom';

import RestartIcon from 'components/Icon/Restart';

import * as S from './Error.styled';

type ErrorProps = {
    errorTitle: string;
    errorDescription: string;
    button: string;
};

export const Error = ({ errorTitle, errorDescription, button }: ErrorProps) => {
    const handleReload = () => {
        window.location.reload();
    };

    return (
        <S.Container data-locator="meal-error" data-testid="meal-error">
            <S.Header>
                <Link to="/meals" data-locator="meal-page-back-link" data-testid="meal-page-back-link">
                    <Icon name="close" size={24} />
                </Link>
            </S.Header>
            <S.Content>
                <S.IconContainer>
                    <RestartIcon />
                </S.IconContainer>
                <Text type="h5-medium" mt={32}>
                    {errorTitle}
                </Text>
                <Text type="medium-text" mt={12} color="text-secondary">
                    {errorDescription}
                </Text>
            </S.Content>

            <Button onClick={handleReload}>{button}</Button>
        </S.Container>
    );
};
